import React from 'react';
import {
    Box,
    Button,
    Container,
    Divider,
    Link,
    Typography,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import ScrollToTopButton from "./ScrollToTopButton";

export default function Privacy() {
    return (
    <Box >
        <ScrollToTopButton />
        <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                bgcolor: '#223f73' }}>
            <Box
            component="img"
            src="/images/logo.png"
            alt="Logo"
            sx={{
                maxWidth: '160px',
                height: 'auto',
                display: 'block',
            }}
            />
            <Button component={NavLink} to='/' sx={{color: 'white', mr: 2}}>
                Home
            </Button>
        </Box>
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
            Privacy Policy
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
            Effective Date: April 1, 2025
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
            Last Revised: April 19, 2025
            </Typography >  

            <Box mt={4}>
            <Typography variant="h6">1. Scope</Typography>
            <Typography paragraph>This Privacy Policy describes how PR Innova Inc. and its brands (“PR Innova,” “we”) collect, use, disclose, and safeguard Personal Information when you:</Typography>

            <Typography component="div" variant="body1">
            <Typography
                component="ol"
                sx={{
                listStyleType: 'decimal',
                m: 2,
                '& li::marker': {
                    fontWeight: 'bold',
                },
                }}
            >
                <li>Visit or use any PR Innova website or mobile app;</li>
                <li>Interact with our SaaS platforms or APIs;</li>
                <li>Communicate via email, SMS, chat, or phone;</li>
                <li>Engage us through a Client Agreement.</li>
            </Typography>
            </Typography>
    
            <Typography variant="h6">2. Personal Information We Collect</Typography>
            <Box sx={{ p: 2 }}>
                <Box
                    sx={{
                    display: "flex",
                    mb: 1,
                    // this ensures the two columns are spaced exactly by their flex values
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Category
                    </Typography>
                    <Typography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>
                    Examples
                    </Typography>
                    <Typography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>
                    Collected From
                    </Typography>                    
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box
                    sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Identifiers
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Name, postal address, phone, email, IP address, account ID
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Forms you submit; account signup
                    </Typography>                    
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box
                    sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Commercial Information
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Transaction details, purchase history, service usage logs
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Your activity on our platforms
                    </Typography>                    
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box
                    sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Geolocation Data
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Approximate location derived from IP or device (when needed for service)	
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Automatically via your browser/device	
                    </Typography>                    
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box
                    sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Support Communications
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Chat or call transcripts, screenshots
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Customer support interactions
                    </Typography>    
                </Box>
                <Box
                    sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2
                    }}
                >
                    <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{ flexBasis: "30%", flexShrink: 0 }}
                    >
                    Usage Data
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Log files, error reports, feature interactions	
                    </Typography>
                    <Typography variant="body2" sx={{ flex: 1 }}>
                    Automatic via server logs
                    </Typography>    
                </Box>                                        
            </Box>

    
            <Typography variant="h6">3. How We Use Personal Information</Typography>
            <Typography component="div" variant="body1">
            <Typography
                component="ol"
                sx={{
                listStyleType: 'decimal',
                m: 2,
                '& li::marker': {
                    fontWeight: 'bold',
                },
                }}
            >
                <li>Provide, operate, and maintain the Services;</li>
                <li>Process transactions and fulfill contractual obligations;</li>
                <li>Send administrative or transactional messages (e.g., password resets, receipts);</li>
                <li>Send marketing communications only with your explicit consent;</li>
                <li>Detect, prevent, and address fraud or security issues;</li>
                <li>Comply with legal obligations.</li>
            </Typography>
            </Typography>
    
            <Typography variant="h6">4. Legal Bases (for users in the EEA/UK)</Typography>
            <Typography component="div" variant="body1">
            <Typography
                component="ul"
                sx={{
                m: 2,
                '& li::marker': {
                    fontWeight: 'bold',
                },
                }}
            >
                <li><strong>Contractual necessity</strong> – to provide requested Services;</li>
                <li><strong>Legitimate interests</strong> – e.g., to improve security and performance;</li>
                <li><strong>Consent</strong> – for marketing emails/SMS;</li>
                <li><strong>Legal obligation</strong> – record keeping, tax, or regulatory requirements.</li>
            </Typography>
            </Typography>
    
            <Typography variant="h6">5. Sharing & Disclosure</Typography>
            <Typography paragraph>We do not sell Personal Information. We share it only:</Typography>
            
            <Typography component="div" variant="body1">
            <Typography
                component="ol"
                sx={{
                listStyleType: 'decimal',
                m: 2,
                '& li::marker': {
                    fontWeight: 'bold',
                },
                }}
            >
                <li><strong>Service Providers</strong> – vetted vendors under confidentiality (cloud hosting, email delivery, payment processors);</li>
                <li><strong>Affiliates & Brands</strong> – within PR Innova Inc. for the purposes outlined above;</li>
                <li><strong>Legal/Compliance</strong> – if required by subpoena, court order, or to protect rights;</li>
                <li><strong>Business Transfers</strong> – in connection with a merger, acquisition, or sale.</li>
            </Typography>
            </Typography>

            <Typography variant="h6">6. Cookies & Tracking</Typography>
            <Typography paragraph>
            We currently do not deploy cookies or pixel tags. If this changes, we will update this Policy and obtain consent where required.
            </Typography>

            <Typography variant="h6">7. Data Retention</Typography>
            <Typography paragraph>
            We keep Personal Information only as long as necessary for the purposes stated or as required by law (e.g., tax record retention).
            </Typography>
            
            <Typography variant="h6">8. Security</Typography>
            <Typography paragraph>
            We use industry-standard safeguards: TLS encryption in transit, encryption at rest, role-based access, and annual security audits. No system is 100 % secure; please use caution in sharing information online.
            </Typography>

            <Typography variant="h6">9. Your Rights</Typography>
            <Typography paragraph>Subject to local law, you may have the right to:</Typography>
            
            <Typography component="div" variant="body1">
            <Typography
                component="ol"
                sx={{
                listStyleType: 'decimal',
                m: 2,
                '& li::marker': {
                    fontWeight: 'bold',
                },
                }}
            >
                <li><strong>Access</strong> – know what data we hold;</li>
                <li><strong>Rectify</strong> – correct inaccuracies;</li>
                <li><strong>Delete</strong> – request erasure (subject to legal retention);</li>
                <li><strong>Restrict or Object</strong> – limit certain processing;</li>
                <li><strong>Portability</strong> – obtain a copy in a machine-readable format;</li>
                <li><strong>Opt Out</strong> – of marketing communications.</li>
            </Typography>
            </Typography>
            <Typography paragraph>Contact <Link href='mailto:privacy@prinnovainc.com'>privacy@prinnovainc.com</Link> to exercise rights.</Typography>

            <Typography variant="h6">California Residents (CCPA/CPRA)</Typography>
            <Typography paragraph
            >We do not sell or share Personal Information for cross-context behavioral advertising. You may request a report of categories collected in the preceding 12 months.
            </Typography>

            <Typography variant="h6">10. International Transfers</Typography>
            <Typography paragraph>
            If we transfer data outside Puerto Rico/U.S., we rely on appropriate safeguards (e.g., Standard Contractual Clauses).
            </Typography>

            <Typography variant="h6">11. Changes to This Policy</Typography>
            <Typography paragraph>
            If we make material changes, we will post a prominent notice and update the “Last Revised” date.
            </Typography>

            <Typography variant="h6">12. Contact Us</Typography>
            <Typography paragraph>
            If you have any questions or concerns about this Privacy Policy or how we handle your personal data, please contact us at:
                <br /><br />
                <strong>PR Innova Inc</strong>
                <br />
                127 Calle Guadalquivir
                <br />
                San Juan PR 00927
                <br />
                <Link href="mailto:privacy@prinnovainc.com">privacy@prinnovainc.com</Link>
                {' '}or{' '}
                <Link href="mailto:support@prinnovainc.com">support@prinnovainc.com</Link>
                <br />
            </Typography>
            </Box>
        </Container>
    </Box>
    )
}
